export default class MatcherPlugin {
    constructor({
        matchers = console.error('You need a `matchers` array to make use of this plugin.'),
    }) {
        this.matchers = matchers;
    }

    query(query, done, skip, error) {
        this.matchers.forEach(matcher => {
            const {
                expression = console.error('No expression given to matcher'),
                callback = (matches, pass) => pass(),
            } = matcher;

            const silentSkip = () => skip({ suppressError: true });

            const matchesExpression = !!query.match(expression) ||
                !!MatcherPlugin.sanitisePostcode(query).match(expression);

            callback(matchesExpression, skip, error, silentSkip, query);
        });
    }

    static sanitisePostcode(string) {
        return string.toUpperCase().replace(/ /g, '');
    }

    static get expressions() {
        const sharedRegexConfig = {
            england: 'AL|CB|CM|CO|EN|IG|IP|LU|MK|NR|PE|RM|SG|SS|WD|B|CV|DE|DY|LE|NG|NN|ST|WS|WV|BD|DH|DL|DN|HD|HG|HU|HX|LN|LS|NE|S|SR|TS|WF|YO|BB|BL|CA|CW|FY|L|LA|M|OL|PR|SK|SY|TF|WA|WN|CH|E|EC|N|NW|SE|SW|W|WC|GU|HA|HP|OX|PO|RG|SL|SN|SO|SP|UB|BN|BR|CR|CT|DA|KT|ME|RH|SM|TN|TW|BA|BH|BS|DT|EX|GL|HR|PL|TA|TQ|TR|WR',
            scotland: 'DD|AB|DG|EH|FK|G[1-9]|HS|IV|KA|KW|KY|ML|PA|PH|TD|ZE',
            wales: 'CF|LD|LL|NP|SA|SY108|SY109|SY100|SY15|SY16|SY17|SY18|SY19|SY20|SY21|SY22|SY23|SY24|SY25|CH[5-8]|HR5',
            northernIreland: 'BT',
            london: 'WC|EC|E|N|NW|SE|SW|W|BR|CR|DA|EN|HA|IG|KT|RM|SM|TW|UB|WD',
            guernsey: 'GY',
            jersey: 'JE',
            isleOfMan: 'IM',
            postcodeEnd: '([ ]?\d[\dA-Z]?[ ]?\d?[ABD-HJLN-UW-Z]{2}))$',
        };
        return {
            england: {
                full: new RegExp(`^((${sharedRegexConfig.england})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(?:${sharedRegexConfig.england})`),
            },
            scotland: {
                full: new RegExp(`^((${sharedRegexConfig.scotland})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(?:${sharedRegexConfig.scotland})`),
            },
            wales: {
                full: new RegExp(`^((${sharedRegexConfig.wales})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(?:${sharedRegexConfig.wales})`),
            },
            northernIreland: {
                full: new RegExp(`^((${sharedRegexConfig.northernIreland})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(${sharedRegexConfig.northernIreland})`),
            },
            london: {
                full: new RegExp(`^((${sharedRegexConfig.london})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(?:${sharedRegexConfig.london})`),
            },
            guernsey: {
                full: new RegExp(`^((${sharedRegexConfig.guernsey})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(${sharedRegexConfig.guernsey})`),
            },
            jersey: {
                full: new RegExp(`^((${sharedRegexConfig.jersey})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(${sharedRegexConfig.jersey})`),
            },
            isleOfMan: {
                full: new RegExp(`^((${sharedRegexConfig.isleOfMan})${sharedRegexConfig.postcodeEnd}`),
                partial: new RegExp(`^(${sharedRegexConfig.isleOfMan})`),
            },
        };
    }
}
